import { render, staticRenderFns } from "./UserCardContact.vue?vue&type=template&id=c3b70084&scoped=true"
import script from "./UserCardContact.vue?vue&type=script&lang=ts"
export * from "./UserCardContact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b70084",
  null
  
)

export default component.exports